import PropTypes from 'prop-types';
import classNames from 'classnames';
import { markdownToRawMarkup } from '../../utils/html-utils';
import ThemeContainer from '../theme-container/ThemeContainer';
import styles from './create-project-banner.module.less';
import VisibleIf from '../VisibleIf';
import Image from '../image/Image';

const CreateProjectBanner = ({ text, illustrationUrl, illustrationDescription, createProjectButton, link }) => {
    const textAsHtml = markdownToRawMarkup(text);

    const hasImage = !!illustrationUrl;

    return (
        <ThemeContainer className={styles.wrapper}>
            <div className={classNames(styles.bannerContainer, !hasImage && styles.bannerContainerNoImage)}>
                <div className={styles.textBlock}>
                    <div className={styles.text} dangerouslySetInnerHTML={textAsHtml} />
                    <div className={styles.buttons}>
                        <div className={styles.button}>{createProjectButton}</div>
                        {link && <div className={styles.linkButton}>{link}</div>}
                    </div>
                </div>
                <VisibleIf isVisible={hasImage}>
                    <div className={styles.imageContainer}>
                        <Image src={illustrationUrl} alt={illustrationDescription} role="presentation" />
                    </div>
                </VisibleIf>
            </div>
        </ThemeContainer>
    );
};

CreateProjectBanner.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.node,
    createProjectButton: PropTypes.node,
    illustrationDescription: PropTypes.string.isRequired,
    illustrationUrl: PropTypes.string.isRequired,
};

CreateProjectBanner.defaultProps = {
    title: null,
    text: null,
    createProjectButton: null,
    link: null,
};

export default CreateProjectBanner;
